<template>
  <div class="flex pt-4 h-full">
    <div class="border-r border-gray-400 px-6">
      <div class="mb-4">
        <p class="text-sm font-semibold text-gray-800 mb-2">
          Created between:
        </p>
        <div class="flex">
          <label class="flex-1 text-sm leading-10 mr-4">From</label>
          <FormulateInput
            v-model="filters.from.value"
            :max="filters.to.value"
            type="date"
            name="from"
            class="w-48"
          />
        </div>
        <div class="flex">
          <label class="flex-1 text-sm leading-10 mr-4">To</label>
          <FormulateInput
            v-model="filters.to.value"
            :min="filters.from.value"
            :max="Date.now()"
            type="date"
            name="to"
            class="w-48"
          />
        </div>
      </div>
      <FormulateInput
        v-model="filters.myLinks.value"
        type="checkbox"
        name="myLinks"
        label="My links"
      />
      <div
        v-for="filter in filters.otherFilters.value"
        :key="`${filter.name}-${filter.selected.value.length}`"
        class="relative flex items-start mb-4"
      >
        <button
          v-show="filter.selected.value.length > 0"
          @click="clearFilter(filter.name)"
          class="absolute top-0 right-0 pl-3 text-lg focus:outline-none text-gray-500 hover:text-red-500"
        >
          <icon-close title="Clear filter" />
        </button>
        <FormulateInput
          :value="filter.selected.value"
          @input="(selected) => updateFilter(filter.name, selected)"
          :options="filterOptions[filter.name]"
          :name="filter.name"
          :label="filterNames[filter.name]"
          :type="filterOptions[filter.name].length <= 5 ? 'checkbox' : 'select'"
          class="flex-1"
        />
      </div>
      <base-button @click="clearFilters" theme="gray">
        Clear all filters
      </base-button>
    </div>
    <div class="flex-1 px-8">
      <slot
        name="before-links"
        :has-links="visibleLinks.length !== 0"
        :filters="filters"
      />

      <dashboard-links-pagination
        :page="page"
        :pageCount="pageCount"
        @change="page = $event"
      />

      <div class="mb-8">
        <slot :links="visibleLinks" />
      </div>

      <dashboard-links-pagination
        :page="page"
        :pageCount="pageCount"
        @change="page = $event"
      />
    </div>
  </div>
</template>

<script>
import DashboardLinksPagination from './DashboardLinksPagination.vue';
import { useFilters } from '../services/useFilters';

export default {
  components: { DashboardLinksPagination },
  props: {
    links: Array,
    userId: Number,
  },
  setup(props) {
    return useFilters(props);
  },
};
</script>
